import {
  ChangeDetectorRef, Component, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output,
  ViewChild, ElementRef, Renderer2
} from '@angular/core';
import { debounceTime, distinctUntilChanged, switchMap, filter, map } from 'rxjs/operators';
import { MatSelect, MatSnackBar, MatDialog, MatDialogRef, MatDialogConfig } from '@angular/material';
import {
  EventMessageComponent
} from '../handler-server-respond/handler-server-respond.component';
import { OrderService } from '../../services/order.service';
import { Observable } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { ModalCloseComponent } from '../../../shared/index';


@Component({
  selector: 'app-assign-car',
  templateUrl: './assign-car.component.html',
  styleUrls: ['./assign-car.component.scss']
})
export class AssignCarComponent implements OnInit, OnDestroy {
  @Output() ClosePopUp = new EventEmitter<boolean>();
  @Input() taxiServices = null;
  @Input() order;
  @ViewChild('serviceTrack', { read: MatSelect }) serviceTrack: MatSelect;
  @ViewChild('search') search: ElementRef;

  items: Array<any>;
  // search: string = null;
  service = null;

  constructor(private snackBar: MatSnackBar,
    private orderService: OrderService,
    private translate: TranslateService,
    private cd: ChangeDetectorRef,
    private renderer: Renderer2,
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<AssignCarComponent>, ) { }

  ngOnInit() {
      this.service = this.order.service_id;
  
    this.searchVehicle().subscribe(obj => {
      this.items = obj['data'];
      this.cd.detectChanges();
    });

    this.serviceTrack.selectionChange.subscribe(data => {
      const event = new Event('input', { bubbles: true });
      this.renderer.selectRootElement(
        this.search.nativeElement).dispatchEvent(event);
    });
  }

  ngOnDestroy() { }

  close() {
    this.ClosePopUp.emit(false);
  }

  searchVehicle<FromEventObservable>() {
    return Observable.fromEvent(this.search.nativeElement, 'input')
      .pipe(
        map((val: any) => val.target.value),
        debounceTime(400),
        filter(text => text.length),
        switchMap((data) => {
          return this.orderService.getCabs({
            'service': this.service,
            'query': data
          });
        })
      );
  }

  assignCab(cab, ignoreBalance = { 'ignore_balance': false }) {
    this.orderService.assignCab({ 'service': this.service, 'cab_id': cab.id, 'id': this.order.id, ...ignoreBalance })
      .subscribe({
        next: val => {
          this.close();
          this.translate.get('CAB_ASSIGNED_MESSAGE').subscribe(res =>
            this.handleServiceEvent(res))
          console.log(val);
        },
        error: err => {
          if (err.error.code === 'not_enough_balance') {
            this.handleServiceEvent('недостаточно средств на балансе водителя');
            this.assignOfConfirm(cab);
          } if (err.error.code === 'request_already_reserved') {
            this.handleServiceEvent('на этот заказ уже назначен водитель');
          } else {
            this.translate.get(err).subscribe(res => {
              console.log(res);
            });
          }
        }
      });
  }
  assignOfConfirm(vehicle) {
    let dialogRef = this.dialog.open(ModalCloseComponent, <MatDialogConfig>{
      data: { 'headerTemplate': 'ASSIGN_OF_CONFIRM' }
    });
    dialogRef.afterClosed().subscribe(data => {
			console.log("TCL: assignOfConfirm -> data", data)
      if (data == 'true') {
        this.assignCab(vehicle, { 'ignore_balance': true })
        this.dialogRef.close;
      }
    });
  }

  private handleServiceEvent(msg) {
    this.snackBar.openFromComponent(EventMessageComponent, {
      duration: 3000,
      verticalPosition: 'top',
      horizontalPosition: 'center',
      data: {
        message: msg
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/assign-car/assign-car.component.ts